import React from 'react'

export default function ProductsSoldInnerStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        /* Modify Parent Style Content Inner */
        #content { background-color: whitesmoke; }

        .report-wrapper { border: solid 0.5px lightgrey; }

        #products-sold-container {
          font-size: 1rem;
          background-color: white;
          box-sizing: border-box;
          padding: 25px;
        }

        .products-sold-table { width: 100%; }
        .products-sold-table th:nth-child(1), .products-sold-table td:nth-child(1) { width: 45%; }
        .products-sold-table th:nth-child(2), .products-sold-table td:nth-child(2) { width: 25%; }
        .products-sold-table th:nth-child(3), .products-sold-table td:nth-child(3) { width: 15%; }
        .products-sold-table th:nth-child(4), .products-sold-table td:nth-child(4) { width: 15%; }

        .products-sold-table .sortable-header { padding: 5px; }
        .products-sold-table .sortable-header:hover { background-color: #D2D6F7; }
        .products-sold-table th { padding: 10px 0; }

        .dates-header-container { display: flex; }
        .dates-header-container .date-left { flex: 1; }
        .dates-header-container .date-right {
          flex: 1;
          text-align: right;
          /*justify-content: flex-end;*/
        }

      `}
      </style>
    </React.Fragment>
  )
}
